<template>
  <MobilePopup
    :popupVisible="popupVisible"
    :src="src"
    :title="title"
    :content="content"
    :text="text"
    @monitorEvent="monitorEvent"
    @closePopup="closePopup">
  </MobilePopup>
</template>
<script>
import MobilePopup from '@/components/MobilePopup'

export default {
  props: {
    popupVisible: Boolean,
    title: String,
    content: String,
    text: String,
    src: String
  },
  methods: {
    monitorEvent () {
      this.$emit('monitorEvent')
    },
    closePopup () {
      this.$emit('closePopup')
    }
  },
  components: {
    MobilePopup
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MobileAddDialog/index.vue